import * as ng from 'angular';
import { MoleculePanelEditRowTableBundleBackupsController } from './bundle-backups';

export class MoleculePanelEditRowTableBundleBackupsConfirmDeletionController implements ng.IController {
    public static $inject: string[] = [];
    public backup: any;
    public opened: boolean;
    public confirmed = false;
    private $backupPanel: MoleculePanelEditRowTableBundleBackupsController;

    public deleteBackup = () => {
        this.$backupPanel.closeRestoreConfirmation();
        this.$backupPanel.deleteBackup(this.backup);
    };

    public cancel = () => {
        this.confirmed = false;
        this.$backupPanel.closeDeleteConfirmation(this.backup);
    };
}

export class MoleculePanelEditRowTableBundleBackupsConfirmDeletionComponent implements ng.IComponentOptions {
    public require = {
        $backupPanel: '^moleculePanelEditRowTableBundleBackups'
    };
    public bindings = {
        backup: '<',
        opened: '<'
    };
    public controller = MoleculePanelEditRowTableBundleBackupsConfirmDeletionController;
    // tslint:disable-next-line: max-line-length
    public template = require('./bundle-backups-confirm-deletion.html');
}
